module.exports = __webpack_public_path__ + "static/media/boat-paddle-paddlewheel-svgrepo-com.cd29f1e5.svg";